module.exports = [
  'AS', // AGUASCALIENTES
  'BC', // BAJA CALIFORNIA
  'BS', // BAJA CALIFORNIA SUR
  'CC', // CAMPECHE
  'CL', // COAHUILA
  'CM', // COLIMA
  'CS', // CHIAPAS
  'CH', // CHIHUAHUA
  'DF', // DISTRITO FEDERAL
  'DG', // DURANGO
  'GT', // GUANAJUATO
  'GR', // GUERRERO
  'HG', // HIDALGO
  'JC', // JALISCO
  'MC', // MÉXICO
  'MN', // MICHOACÁN
  'MS', // MORELOS
  'NT', // NAYARIT
  'NL', // NUEVO LE”N
  'OC', // OAXACA
  'PL', // PUEBLA
  'QT', // QUERÉTARO
  'QR', // QUINTANA ROO
  'SP', // SAN LUIS POTOSÍ
  'SL', // SINALOA
  'SR', // SONORA
  'TC', // TABASCO
  'TS', // TAMAULIPAS
  'TL', // TLAXCALA
  'VZ', // VERACRUZ
  'YN', // YUCATÁN
  'ZS', // ZACATECAS
  'NE', // NACIDO EN EL EXTRANJERO
];
